import { useState } from 'react';
import { Modal } from '../../shared/ui/Modal';
import { Button } from '../../shared/ui/Button';
import { useToast } from '../../shared/hooks/useToast';
import { useAnnouncements } from './useAnnouncements';

export function UrgentAnnouncementGate() {
  const { unread, acknowledge } = useAnnouncements();
  const toast = useToast();
  // Fechar no X/ESC só esconde nesta sessão (estado local): volta na próxima abertura.
  const [hidden, setHidden] = useState<Set<string>>(new Set());

  // unread vem do mais novo para o mais antigo: o último urgente não escondido é o mais antigo.
  const a = unread.filter((x) => x.urgent && !hidden.has(x.id)).at(-1);
  if (!a) return null;
  const id = a.id;

  async function entendi(): Promise<void> {
    try {
      await acknowledge(id);
    } catch (e) {
      console.error('[announcements] acknowledge', e);
      toast.error('Não foi possível registrar o "Entendi". Tente novamente.');
    }
  }

  return (
    <Modal
      open
      onClose={() => setHidden((s) => new Set(s).add(id))}
      title={a.title}
      footer={<Button onClick={() => void entendi()}>Entendi</Button>}
    >
      <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{a.body}</p>
    </Modal>
  );
}
